/* jshint esversion: 6 */
import GtmService from '../gtm/gtm.service';

const IS_DEV = window.location.pathname.match(/\.html$/i);
const QUERYSTRING_KEY = 'q';

class SearchbarCtrl {

	constructor(
		$scope,
		$location,
		$timeout,
		$http,
		StateService
	) {
		this.$scope = $scope;
		this.$location = $location;
		this.$timeout = $timeout;
		this.$http = $http;
		this.data = window.data || {};
		this.model = {};
		this.state = StateService.getState();
		this.state.ready();
		//if (this.$location.search() && this.$location.search()[QUERYSTRING_KEY]) {
		//	this.model.search = this.$location.search()[QUERYSTRING_KEY];
		//	this.onSubmit();
		//}
	}


	onSearch() {
		// Don't search if the search term is empty or undefined
		if (!this.model.search || this.model.search.trim() === '') {
			return;
		}

		//console.log("--search" + encodeURIComponent(this.model.search));
		//const obj = Object.assign({}, window.objDataLayerInfo);
		//obj["eventname"] = "search";
		//obj["searchterm"] = encodeURIComponent(this.model.search);
		//GtmService.push(obj);

		// console.log('SearchCtrl.onSearch', this.model);
		window.location.href = `${this.searchHref}?${QUERYSTRING_KEY}=${this.model.search}`;
	}

	onInvalid() {
		this.$scope.$broadcast('onInvalid');
	}

}

SearchbarCtrl.$inject = ['$scope', '$location', '$timeout', '$http', 'StateService'];

export default SearchbarCtrl;
